export default __webpack_public_path__ + "static/media/shuffle-red.8ee04cde.png";